module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles